export interface RegisterSystemUserLinkRequest {
  title: string
  url: string
}

export function RegisterSystemUserLinkRequestToJSON(
  value: RegisterSystemUserLinkRequest
): any {
  return {
    title: value.title !== '' ? value.title : undefined,
    url: value.url !== '' ? value.url : undefined
  }
}
